import './loginCard.scss';
import React, { Fragment } from 'react';
import { useContext, useRef, useMemo } from 'react';
import { AppContext } from '../../context/appContext';
import If from '../../common/components/if';
import { getPinUrl } from '../../common/utils/umuUtil';
import { PlatformActionList, LanguageSwitch, FontSizeSwitch, PlainText, AccountSwitch, GotoPlatformNavItem } from '../';
import { getUpgradeUrl, isOnlyAITools } from '../../utils/util';
import { SYSTEM } from '../../base/contextService';
import { isCanShowFontSizeSwitch } from '../../../../businessCommon/src/@utils/fontSize';

export function LoginCard() {
    const appContext = useContext(AppContext);
    const { enterpriseInfo, isCAdministrator, system, userInfo, lang, isInAITools } = appContext.state;
    const isEnterpriseAccount = enterpriseInfo.enterprise_id !== '0';
    const enterpriseAccountType = Number(enterpriseInfo.role_type);
    const isSystemCN = system === SYSTEM.CN;
    const isSystemJP = system === SYSTEM.JP;
    const isSystemEM = system === SYSTEM.EM;
    const isSystemEN = system === SYSTEM.EN;
    const helpCenterLinkNotion =
        'https://umu-help-center.notion.site/UMU-Help-Center-143bd819b66180c6b06acba24680ab0c?pvs=73';
    const helpCenterLink = '/help';
    const _helpCenterLink = isSystemEM || isSystemEN ? helpCenterLinkNotion : helpCenterLink;
    const isSystemATES = system === SYSTEM.ATES;
    const isShowFontSizeSwitch = isCanShowFontSizeSwitch();
    const loginCardRef = useRef<HTMLDivElement>();

    const pinUrl = useMemo(() => getPinUrl(), []);
    const memberUrl = useMemo(() => {
        return getUpgradeUrl(system, userInfo.member_type);
    }, [system, userInfo]);

    const navShow = (page: string) => {
        return {
            index: true,
            task: true,
            course: true,
            weike: true,
            program: !isEnterpriseAccount || enterpriseAccountType != 1,
            class: true,
            courseResource: !isEnterpriseAccount || enterpriseAccountType != 1,
            templateManage: !isEnterpriseAccount || enterpriseAccountType != 1,
            member: !isEnterpriseAccount,
            invite: !isEnterpriseAccount,
            download: !isEnterpriseAccount,
            help: !isEnterpriseAccount || enterpriseAccountType != 1,
            platformManage: (isEnterpriseAccount && enterpriseAccountType >= 3) || isCAdministrator,
        }[page];
    };

    const getFAQText = () => {
        if (lang === 'ja-jp') {
            return 'よくある質問';
        }
        return 'FAQ';
    };

    const getAcadeMyText = () => {
        if (lang === 'ja-jp' || lang === 'en-us') {
            return 'UMU Academy';
        }
        return 'UMU 小课堂';
    };

    return (
        <div className="login-state-card" ref={loginCardRef} data-role="js_login-state-card">
            <AccountSwitch />

            <ul className="links">
                <If condition={!isInAITools}>
                    <li className="link">
                        <a className="trackEvent" href={pinUrl} target="blank">
                            <PlainText>输入访问码</PlainText>
                        </a>
                    </li>
                </If>
                <If condition={!!(navShow('member') && !isSystemATES && !isInAITools)}>
                    <li className="link">
                        <a href={memberUrl} className=" btn trackEvent" ng-className="{'member':'current'}[currentTab]">
                            <PlainText>会员升级</PlainText>
                        </a>
                    </li>
                </If>

                <If condition={!!(navShow('download') && !isInAITools)}>
                    <li className="link">
                        <a href="/download" className=" btn trackEvent">
                            <PlainText>APP下载</PlainText>
                        </a>
                    </li>
                </If>

                <If condition={!!(navShow('help') && !isInAITools)}>
                    <li className="link">
                        {isSystemCN && (
                            <a href="/index?eid=academy#/index" target="_blank" className="btn">
                                <PlainText>UMU小课堂</PlainText>
                            </a>
                        )}
                        {!isSystemCN && (
                            <a href={_helpCenterLink} rel="noreferrer" target="_blank" className="btn">
                                <PlainText>帮助</PlainText>
                            </a>
                        )}
                    </li>
                </If>
                <If condition={isSystemEN && !isInAITools}>
                    <li className="link">
                        <a href="https://e.umu.com/umuacademy" target="_blank" rel="noreferrer" className="btn">
                            <PlainText>UMU小课堂</PlainText>
                        </a>
                    </li>
                </If>
                <If condition={isSystemJP}>
                    <Fragment>
                        <li className="link">
                            <a
                                href="https://tayori.com/faq/e789bde6e91c09073e63704a4be1872ac2b27902/"
                                target="_blank"
                                rel="noreferrer"
                                className="btn"
                            >
                                <PlainText>{getFAQText()}</PlainText>
                            </a>
                        </li>
                        <li className="link">
                            <a
                                href="https://www.umu.co/index?eid=umu_academy#/index"
                                target="_blank"
                                rel="noreferrer"
                                className="btn"
                            >
                                <PlainText>{getAcadeMyText()}</PlainText>
                            </a>
                        </li>
                    </Fragment>
                </If>
                <PlatformActionList />
                <li className="link">{<LanguageSwitch loginCardRef={loginCardRef} />}</li>
                {isShowFontSizeSwitch && !isInAITools && (
                    <li className="link">{<FontSizeSwitch loginCardRef={loginCardRef} />}</li>
                )}
                {isInAITools && !isOnlyAITools(isInAITools, isEnterpriseAccount, userInfo?.umu_id || '') && (
                    <li className="link">{<GotoPlatformNavItem />}</li>
                )}
            </ul>
        </div>
    );
}
